import script from "./MonarchTransactionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./MonarchTransactionsView.vue?vue&type=script&setup=true&lang=js"

import "./MonarchTransactionsView.vue?vue&type=style&index=0&id=272dedde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-272dedde"]])

export default __exports__